<script setup>
const { format: formatDate } = useDate();
const { $get } = useAxios();

const route = useRoute();

useHead({
  // Can be static or computed
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Пресса | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Пресса | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});

const { data: pressList, pending: isLoaded } = await useAsyncData(
  `/api/v3/press`,
  () => $get(`/api/v3/press`)
);
</script>

<template>
  <nuxt-layout name="default">
    <div v-if="!isLoaded">
      <r-section v-if="pressList">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-7">
          <a
            class="bg-white px-5 py-4 flex flex-col space-y-1 rounded-lg"
            v-for="press in pressList"
            :key="press._id"
            :href="press.link"
            target="_blank"
          >
            <h6 class="text-lg text-gray-dark">
              {{ formatDate(press.createdAt, "DD.MM.YYYY") }}
            </h6>
            <h2 class="text-xl text-gray-dark">{{ press.name }}</h2>
            <p class="text-lg text-primary">{{ press.author }}</p>
          </a>
        </div>
      </r-section>
    </div>
    <r-full-page-pro-loader v-else></r-full-page-pro-loader>
  </nuxt-layout>
</template>
